import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Divider,
  Link,
  IconButton,
} from '@mui/material';
import { Twitter, Facebook, LinkedIn, WhatsApp } from '@mui/icons-material';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const sections = [
    { title: 'À propos de nous', links: [{ name: 'Aperçu', url: 'ApercuINSBU' }, { name: 'Historique de l\'INSBU', url: 'historiqueINSBU' }, { name: 'Coordination du SSN', url: 'CoordinationSSN' }], width: 2 },
    { title: 'Nos services', links: [{ name: 'Visa statistique', url: 'visaStatistique' }, { name: 'Bibliothèque', url: 'bibliotheque' }], width: 2 },
    { title: 'Presse', links: [{ name: 'Communiqués de presse', url: 'communiquesPresse' }, { name: 'Actualités et événements', url: 'actualitesEtEvenements' }], width: 2 },
    { title: 'Annonces', links: [{ name: 'Offre d\'emplois et Appels d\'offres', url: 'recruitmentPage' }, { name: 'Informations sur le visa statistique', url: '/visaInformation' }], width: 2 },
    { title: 'Nos plateformes', links: [{ name: 'Burundi OPEN DATA', url: 'https://burundi.opendataforafrica.org/' }, { name: 'IMIS Burundi', url: 'http://41.79.224.140/redbdi/' }, { name: 'Burundi NADA', url: 'https://insbu.bi/nada/index.php/accueil' }], width: 2 },
    { title: 'Réseaux sociaux', isSocial: true, width: 2 },
  ];

  // Date formatée en français
  const formatDate = () => {
    const date = new Date();
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    };
    return date.toLocaleDateString('fr-FR', options);
  };

  return (
    <Box
      sx={{
        bgcolor: '#212121',
        color: '#fff',
        py: 5,
      }}
      component="footer"
    >
      <Container maxWidth="lg">
        <Grid container spacing={6}>
          {sections.map((section, index) => (
            <Grid item xs={12} sm={4} md={section.width} key={index} sx={{ textAlign: 'left' }}>
              <Typography variant="h6" color="inherit" gutterBottom>
                {section.title}
              </Typography>
              {section.isSocial ? (
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <IconButton 
                    href="https://twitter.com/INSBURUNDI" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    color="inherit"
                    sx={{
                      '&:hover': { color: '#1DA1F2', backgroundColor: 'rgba(29, 161, 242, 0.1)' }
                    }}
                  >
                    <Twitter />
                  </IconButton>
                  <IconButton 
                    href="https://www.facebook.com/profile.php?id=61581042730925" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    color="inherit"
                    sx={{
                      '&:hover': { color: '#1877F2', backgroundColor: 'rgba(24, 119, 242, 0.1)' }
                    }}
                  >
                    <Facebook />
                  </IconButton>
                  <IconButton 
                    href="https://www.linkedin.com/in/ins-burundi-70a97237b/" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    color="inherit"
                    sx={{
                      '&:hover': { color: '#0A66C2', backgroundColor: 'rgba(10, 102, 194, 0.1)' }
                    }}
                  >
                    <LinkedIn />
                  </IconButton>
                  <IconButton 
                    href="https://whatsapp.com/channel/0029VaIPXsuG3R3eWCaadr2n" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    color="inherit"
                    sx={{
                      '&:hover': { color: '#25D366', backgroundColor: 'rgba(37, 211, 102, 0.1)' }
                    }}
                  >
                    <WhatsApp />
                  </IconButton>
                </Box>
              ) : (
                section.links.map((link, idx) => (
                  <Typography key={idx} variant="body2" color="inherit" gutterBottom sx={{ mt: 1 }}>
                    <Link 
                      href={link.url} 
                      color="inherit" 
                      underline="hover"
                      sx={{
                        '&:hover': { color: '#4CAF50' }
                      }}
                    >
                      {link.name}
                    </Link>
                  </Typography>
                ))
              )}
            </Grid>
          ))}
        </Grid>

        <Divider sx={{ my: 3, backgroundColor: 'rgba(255, 255, 255, 0.1)' }} />

        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Typography variant="body2" color="inherit" gutterBottom>
              Dernière mise à jour : {formatDate()}
            </Typography>
            <Typography variant="body2" color="inherit" gutterBottom>
              Copyright © {currentYear} Institut National de la Statistique du Burundi. Tous droits réservés.
            </Typography>
          </Grid>
          <Grid item xs={12} md={5} sx={{ textAlign: { xs: 'right', md: 'left' } }}>

               
            <Typography variant="body2" color="inherit" gutterBottom>
              Liens utiles :
              <br />
              <Link 
                href="https://presidence.gov.bi/" 
                color="inherit" 
                underline="hover" 
                target="_blank" 
                rel="noopener noreferrer"
                sx={{ '&:hover': { color: '#4CAF50' } }}
              >
                Présidence de la République du Burundi
              </Link>
              <br />
              <Link 
                href="https://finances.gov.bi/" 
                color="inherit" 
                underline="hover" 
                target="_blank" 
                rel="noopener noreferrer"
                sx={{ '&:hover': { color: '#4CAF50' } }}
              >
                Ministère des finances, du budget et de la planification économique
              </Link>
              <br />
              <Link 
                href="https://www.brb.bi/" 
                color="inherit" 
                underline="hover" 
                target="_blank" 
                rel="noopener noreferrer"
                sx={{ '&:hover': { color: '#4CAF50' } }}
              >
                Banque de la République du Burundi
              </Link>
              <br />
              <Link 
                href="https://www.obr.bi/index.php/en/" 
                color="inherit" 
                underline="hover" 
                target="_blank" 
                rel="noopener noreferrer"
                sx={{ '&:hover': { color: '#4CAF50' } }}
              >
                Office Burundais des Recettes
              </Link>
              <br />
              <Link 
                href="https://minfpte.gov.bi/" 
                color="inherit" 
                underline="hover" 
                target="_blank" 
                rel="noopener noreferrer"
                sx={{ '&:hover': { color: '#4CAF50' } }}
              >
                Ministère de la Fonction Publique, du Travail et de l'Emploi
              </Link>
              <br />
              <Link 
                href="https://communication.rusansuma.bi/" 
                color="inherit" 
                underline="hover" 
                target="_blank" 
                rel="noopener noreferrer"
                sx={{ '&:hover': { color: '#4CAF50' } }}
              >
                Bureau Central du Recensement
              </Link>
                <br />
              <Link 
                href="https://www.unfpa.org/" 
                color="inherit" 
                underline="hover" 
                target="_blank" 
                rel="noopener noreferrer"
                sx={{ '&:hover': { color: '#4CAF50' } }}
              >
                Fonds des Nations Unies pour la Population (UNFPA)
              </Link>
              <br />
                  <Link 
                href="https://www.banquemondiale.org/ext/fr/home" 
                color="inherit" 
                underline="hover" 
                target="_blank" 
                rel="noopener noreferrer"
                sx={{ '&:hover': { color: '#4CAF50' } }}
              >
                Banque Mondiale
              </Link>
            </Typography>


            
          </Grid>
          <Grid item xs={12} md={1} sx={{ textAlign: { xs: 'left', md: 'right' } }}>
            <Typography variant="body2" color="inherit">
              <Link 
                href="/useragreement" 
                color="inherit" 
                underline="hover" 
                sx={{ 
                  display: 'block', 
                  mb: 1,
                  '&:hover': { color: '#4CAF50' } 
                }}
              >
                Conditions d'utilisation
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;